export default __webpack_public_path__ + "static/media/checkin_default_tile.8f856317.png";